// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__cF99Y","inputBlock":"styles_inputBlock__1tgDa","heading":"styles_heading__2Ofpx","addButtonStyles":"styles_addButtonStyles__jX1kD"};